import { combineReducers, configureStore } from '@reduxjs/toolkit';

import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

import { authReducer } from './auth.slice';
import cartReducer from "./cart.slice";
import productReducer from "./product.slice";

import { thunk } from 'redux-thunk';
import appConfig from '../config';


export * from './auth.slice';

const authPersistConfig = {
    key: "auth",
    storage,
    blacklist: ["cart"],
  };
  
  const cartPersistConfig = {
    key: "cart",
    storage,
  };

  const rootReducer = combineReducers({
    auth: persistReducer(authPersistConfig, authReducer),
    cart: persistReducer(cartPersistConfig, cartReducer),
    products: persistReducer({ key: 'products', storage }, productReducer),
  });

// const reducers = combineReducers({
//     auth: authReducer,
// });

// const persistConfig = {
//     key: 'root',
//     storage
// };

// const persistedReducer = persistReducer(persistConfig, reducers);


export const store = configureStore({
    reducer: rootReducer,
    devTools: appConfig.app_env !== 'production',
    middleware: () => [thunk]
});

//development" | "production" | "test"